// extracted by mini-css-extract-plugin
export default {"primary":"Button_primary__R2l9b","transparent":"Button_transparent__Y57oW","prodCatButton":"Button_prodCatButton__K2SlS"};